import TripPlanContentStepBased from 'components/TripScreen/TripPlanScreen/TripPlanContent/TripPlanContentStepBased';
import TripPlanContentTransit from 'components/TripScreen/TripPlanScreen/TripPlanContent/TripPlanContentTransit';
import tripscreen from 'utils/tripscreen';

function TripPlanContent({ name, tripPlan, endingLocation, params }) {
    if (tripscreen.isTransitTrip(name)) {
        return <TripPlanContentTransit tripPlan={tripPlan} endingLocation={endingLocation} params={params} />
    }
    else if (tripscreen.isNonTransitTrip(name)) {
        // Todo: Ridehailing only needs the 2nd leg, which is the drive
        if (name === 'RideHailing') {
            tripPlan = {
                ...tripPlan,
                legs: tripPlan.legs.length > 1 ? [tripPlan.legs[1]] : tripPlan.legs
            }
        }
        return <TripPlanContentStepBased tripPlan={tripPlan} endingLocation={endingLocation} params={params} />
    }
    else {
        return <div className="TripPlanContent">Trip plan content for {name} coming soon... </div>
    }
}

export default TripPlanContent
